var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _path, _circle, _circle2, _path2, _path3, _circle3, _circle4, _path4, _path5, _circle5, _circle6, _path6, _path7, _circle7, _circle8, _path8, _path9, _path10, _path11, _circle9, _circle10, _path12, _circle11, _circle12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCradle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientTransform: "matrix(.961 .278 -.278 .961 40.509 -28.11)",
    gradientUnits: "userSpaceOnUse",
    x1: 100.869,
    x2: 163.96,
    y1: 364.331,
    y2: 427.422
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientTransform: "matrix(.961 .278 -.278 .961 40.509 -28.11)",
    gradientUnits: "userSpaceOnUse",
    x1: 124.94,
    x2: 94.884,
    y1: 390.843,
    y2: 348.232
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcee21"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientTransform: "matrix(.961 .278 -.278 .961 40.509 -28.11)",
    gradientUnits: "userSpaceOnUse",
    x1: 120.787,
    x2: 187.745,
    y1: 401.226,
    y2: 276.695
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b53759"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 201.657,
    x2: 264.747,
    y1: 364.594,
    y2: 427.685
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f92814"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.727,
    x2: 195.671,
    y1: 391.106,
    y2: 348.495
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 221.574,
    x2: 288.532,
    y1: 401.489,
    y2: 276.957
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1272d"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 299.082,
    x2: 362.172,
    y1: 364.594,
    y2: 427.685
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cffc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a98f7"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 323.152,
    x2: 293.096,
    y1: 391.106,
    y2: 348.495
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cffc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65e1dc"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 319,
    x2: 385.957,
    y1: 401.489,
    y2: 276.957
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0469bc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469bc"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 396.507,
    x2: 459.598,
    y1: 364.594,
    y2: 427.685
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92f37f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ab272"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 420.578,
    x2: 390.522,
    y1: 391.106,
    y2: 348.495
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92f37f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffee83"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 416.425,
    x2: 483.383,
    y1: 401.489,
    y2: 276.957
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ab272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0ddfc"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientTransform: "matrix(0 1 1 0 257.208 -257.208)",
    gradientUnits: "userSpaceOnUse",
    x1: 348.481,
    x2: 382.938,
    xlinkHref: "#lg1",
    y1: 11.387,
    y2: 11.387
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientTransform: "matrix(0 1 1 0 257.208 -257.208)",
    gradientUnits: "userSpaceOnUse",
    x1: 315.394,
    x2: 396.434,
    y1: 20.496,
    y2: 4.911
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9edf5",
    stopOpacity: 0
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ddfc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#c8b7e0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#a595c8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8f81b8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779b3"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientTransform: "matrix(0 1 1 0 257.208 -257.208)",
    gradientUnits: "userSpaceOnUse",
    x1: 404.195,
    x2: 350.432,
    xlinkHref: "#lg2",
    y1: -138.055,
    y2: -191.817
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.931,
    x2: 84.715,
    xlinkHref: "#lg1",
    y1: 97.209,
    y2: 135.993
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9edf5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.919,
    x2: 39.819,
    xlinkHref: "#lg3",
    y1: 118.197,
    y2: 91.097
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.175,
    x2: 99.336,
    xlinkHref: "#lg2",
    y1: 119.889,
    y2: 43.336
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 468.85,
    x2: 507.634,
    xlinkHref: "#lg1",
    y1: 97.209,
    y2: 135.993
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 489.838,
    x2: 462.739,
    xlinkHref: "#lg3",
    y1: 118.197,
    y2: 91.097
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 481.094,
    x2: 522.255,
    xlinkHref: "#lg2",
    y1: 119.889,
    y2: 43.336
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m55.424 374.817-13.616-3.934 73.737-255.214c1.086-3.76 5.015-5.927 8.775-4.841 3.76 1.086 5.927 5.015 4.841 8.775z",
    fill: "#555a66"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.725,
    cy: 372.474,
    fill: "url(#SVGID_1_)",
    r: 48.713
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.725,
    cy: 372.474,
    fill: "url(#SVGID_2_)",
    r: 40.655
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m81.755 336.659c1.336 7.211 1.062 14.835-1.113 22.36-7.468 25.846-34.474 40.745-60.32 33.277-7.526-2.174-14.121-6.008-19.508-10.984 3.253 17.555 16.07 32.666 34.39 37.959 25.846 7.467 52.852-7.431 60.319-33.277 5.294-18.32-.653-37.221-13.768-49.335z",
    fill: "url(#SVGID_3_)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m226.969 383.212h-14.172v-265.653c0-3.914 3.173-7.086 7.086-7.086 3.914 0 7.086 3.173 7.086 7.086z",
    fill: "#555a66"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.883,
    cy: 382.82,
    fill: "url(#SVGID_4_)",
    r: 48.713
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.883,
    cy: 382.82,
    fill: "url(#SVGID_5_)",
    r: 40.655
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m241.673 339.245c3.285 6.557 5.137 13.957 5.137 21.791 0 26.903-21.809 48.713-48.713 48.713-7.833 0-15.233-1.852-21.791-5.137 7.998 15.963 24.506 26.922 43.575 26.922 26.903 0 48.713-21.809 48.713-48.712.001-19.071-10.958-35.579-26.921-43.577z",
    fill: "url(#SVGID_6_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m324.394 383.212h-14.172v-265.653c0-3.914 3.173-7.086 7.086-7.086 3.914 0 7.086 3.173 7.086 7.086z",
    fill: "#555a66"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 317.308,
    cy: 382.82,
    fill: "url(#SVGID_7_)",
    r: 48.713
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 317.308,
    cy: 382.82,
    fill: "url(#SVGID_8_)",
    r: 40.655
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m339.098 339.245c3.285 6.557 5.137 13.957 5.137 21.791 0 26.903-21.809 48.713-48.713 48.713-7.833 0-15.233-1.852-21.791-5.137 7.998 15.963 24.505 26.922 43.575 26.922 26.903 0 48.712-21.809 48.712-48.712.002-19.071-10.957-35.579-26.92-43.577z",
    fill: "url(#SVGID_9_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m421.819 383.212h-14.172v-265.653c0-3.914 3.173-7.086 7.086-7.086 3.914 0 7.086 3.173 7.086 7.086z",
    fill: "#555a66"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 414.733,
    cy: 382.82,
    fill: "url(#SVGID_10_)",
    r: 48.713
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 414.733,
    cy: 382.82,
    fill: "url(#SVGID_11_)",
    r: 40.655
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m436.524 339.245c3.285 6.557 5.137 13.957 5.137 21.791 0 26.903-21.809 48.713-48.713 48.713-7.833 0-15.233-1.852-21.791-5.137 7.998 15.963 24.505 26.922 43.575 26.922 26.903 0 48.713-21.809 48.713-48.712.001-19.071-10.959-35.579-26.921-43.577z",
    fill: "url(#SVGID_12_)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m472.171 108.413c0-9.842-7.978-17.82-17.82-17.82h-389.332v35.64h389.332c9.842-.001 17.82-7.979 17.82-17.82z",
    fill: "url(#SVGID_13_)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m471.247 114.047c-2.36 7.077-9.026 12.186-16.896 12.186h-389.332v-24.372h389.332c7.871 0 14.537 5.108 16.896 12.186z",
    fill: "url(#SVGID_14_)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m116.219 126.232h-35.64v-35.639z",
    fill: "url(#SVGID_15_)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.135,
    cy: 108.412,
    fill: "url(#SVGID_16_)",
    r: 29.945
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.135,
    cy: 108.413,
    fill: "url(#SVGID_17_)",
    r: 24.992
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m70.531 81.625c2.02 4.031 3.158 8.58 3.158 13.395 0 16.538-13.407 29.945-29.945 29.945-4.815 0-9.364-1.138-13.395-3.158 4.917 9.813 15.064 16.55 26.787 16.55 16.538 0 29.945-13.407 29.945-29.945 0-11.722-6.738-21.87-16.55-26.787z",
    fill: "url(#SVGID_18_)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 480.055,
    cy: 108.412,
    fill: "url(#SVGID_19_)",
    r: 29.945
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 480.055,
    cy: 108.413,
    fill: "url(#SVGID_20_)",
    r: 24.992
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m493.45 81.625c2.02 4.031 3.158 8.58 3.158 13.395 0 16.538-13.407 29.945-29.945 29.945-4.815 0-9.364-1.138-13.395-3.158 4.917 9.813 15.064 16.55 26.787 16.55 16.538 0 29.945-13.407 29.945-29.945 0-11.722-6.737-21.87-16.55-26.787z",
    fill: "url(#SVGID_21_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCradle);
export default __webpack_public_path__ + "static/media/icon-cradle.380106179188c0c03458f09707766c65.svg";
export { ForwardRef as ReactComponent };